export default __webpack_public_path__ + "static/media/3.d0a81f2b.webp";